export { default } from '@shikijs/langs/svelte'
